/* eslint-disable max-len */
import React from 'react';

const OpenURL: React.FC = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_8816_152428)">
                <path
                    d="M15 10L15 12C15 13.6569 13.6569 15 12 15L4 15C2.34315 15 1 13.6569 1 12L1 4C0.999999 2.34315 2.34315 1 4 1L6 1"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M10.0503 1.00093L15 1.00093M15 1.00093L15 5.95068M15 1.00093L7.92893 8.072"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_8816_152428">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>

    );
};

export default OpenURL;